import React, { useEffect, useState } from "react";
import CrudPage, { ActiveBadge } from "@/components/CrudPage";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function Employees() {
  const [meta, setMeta] = useState({ departments: [] });
  useEffect(() => { api.get("/meta/options").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  const deptName = (c) => meta.departments.find((d) => d.code === c)?.name || c;

  return (
    <CrudPage
      title="Personel"
      subtitle="Personel tanımlama ve yetkinlik yönetimi"
      endpoint="employees"
      testidPrefix="employees"
      defaultForm={{ active: true }}
      columns={[
        { key: "code", label: "Kod" },
        { key: "name", label: "Ad Soyad" },
        { key: "title", label: "Ünvan" },
        { key: "department_codes", label: "Bölümler", render: (e) => (
          <div className="flex flex-wrap gap-1">
            {(e.department_codes || []).map((c) => (
              <Badge key={c} variant="outline" className="text-xs border-border">{deptName(c)}</Badge>
            ))}
          </div>
        ) },
        { key: "skills", label: "Yetkinlikler", render: (e) => (
          <span className="text-xs text-muted-foreground">
            {(e.skills || []).map((s) => `${s.label} (${s.level})`).join(", ") || "-"}
          </span>
        ) },
        { key: "active", label: "Durum", render: (e) => <ActiveBadge value={e.active} /> },
      ]}
      fields={[
        { name: "code", label: "Personel Kodu", required: true, placeholder: "Örn: EMP-11" },
        { name: "name", label: "Ad Soyad", required: true },
        { name: "title", label: "Ünvan", placeholder: "Operatör, Usta..." },
        { name: "department_codes_text", label: "Bölüm Kodları (virgülle)", placeholder: "CNC,KAYNAK", full: true },
        { name: "skills_text", label: "Yetkinlikler (İş:Seviye, virgülle)", placeholder: "CNC-01:Uzman, ENJ-01:Orta", full: true },
        { name: "active", label: "Aktif", type: "checkbox" },
      ]}
      toForm={(e) => ({
        ...e,
        department_codes_text: (e.department_codes || []).join(","),
        skills_text: (e.skills || []).map((s) => `${s.label}:${s.level}`).join(","),
      })}
      toPayload={(f) => ({
        code: f.code, name: f.name, title: f.title || "", active: f.active !== false,
        department_codes: (f.department_codes_text || "").split(",").map((s) => s.trim()).filter(Boolean),
        skills: (f.skills_text || "").split(",").map((s) => s.trim()).filter(Boolean).map((s) => {
          const [label, level] = s.split(":");
          return { label: label?.trim(), level: (level || "Orta").trim() };
        }),
      })}
    />
  );
}
